module.exports = __webpack_public_path__ + "img/st.52d0e644.jpg";